export const standardPeriods = [
  'Last30Days',
  'Last3Months',
  'Last6Months',
  'Last12Months',
  'YTD',
];

export const ReconsiderationsOutcomeVolumeConstants = {
  CustomMonth: 'CustomMonth',
  CustomDay: 'CustomDay',
  CalendarYear: 'CalendarYear',
  Last3Months: 'Last3Months',
  OVERTURNED: 'OVERTURNED',
  UPHELD: 'UPHELD',
  DOS: 'DOS',
  Last12Months: 'Last12Months',
  ReceivedDate: 'Received Date',
  All: 'All',
  overturned: 'overturned',
  upheld: 'upheld',
};
